<template>
  <a
    class="product-card-simple"
    :class="{
      [$class('loading')]: !product,
      'show-secondary-image': showSecondaryImage,
    }"
    :href="product.url"
    @focus="loadSecondaryImage = true"
    @mouseenter="loadSecondaryImage = true"
  >
    <div class="product-card-simple__image-container">
      <responsive-image
        class="product-card-simple__primary-image"
        :image="product.featuredImage"
        min-max="200-500"
        ratio="1:1"
        sizes="(min-width: 1140px) 25vw, 50vw"
      />

      <responsive-image
        v-if="loadSecondaryImage && product.secondaryImage"
        class="product-card-simple__secondary-image"
        :image="product.secondaryImage"
        min-max="200-500"
        :padding="false"
        ratio="1:1"
        sizes="(min-width: 1140px) 25vw, 50vw"
        @image-loaded="showSecondaryImage = true"
      />
    </div>

    <div class="product-card-simple__footer">
      <product-vendor
        class="product-card-simple__vendor"
        :product="product"
      />

      <p
        class="
        product-card-simple__title
        text-heading-s
      "
        v-text="product.title"
      />

      <product-prices
        class="product-card-simple__prices"
        class-compare-at-price="text-other-sale-l"
        class-price="text-body-m-regular"
        :available="product?.available"
        :compare-at-price="product?.compareAtPrice?.amount"
        :price="product?.price?.amount"
        :varies="product?.price?.varies"
      />
    </div>
  </a>
</template>

<script>

/**
 * Vue: Product card simple (product-card-simple)
 * -----------------------------------------------------------------------------
 * Product card simple used throughout the site.
 *
 * @param {Boolean|Object} product - Product object, false shows loading state.
 *
 */
import ProductPrices from '~global/product-prices/product-prices'
import ProductVendor from '~async/product-vendor/product-vendor'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductCardSimple',

  components: {
    ProductPrices,
    ProductVendor,
    ResponsiveImage,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  data() {
    return {
      loadSecondaryImage: false,
      showSecondaryImage: false,
    }
  },
}
</script>

<style lang="scss">
@import './product-card-simple';
</style>
